/**
 * Gerencia a lista dos ultimos pacientes acessados por clinica.
 * Persiste em localStorage; falhas sao silenciosas (modo privado, quota, etc).
 */
const KEY_PREFIX = 'dratento:recentPatients:';
const MAX_RECENT = 50;

function storageKey(clinicId: string): string {
  return KEY_PREFIX + clinicId;
}

/**
 * Marca um paciente como "acessado agora". Se ja existia na lista, move pro topo.
 * Mantem no maximo MAX_RECENT ids.
 */
export function addRecentPatient(clinicId: string, patientId: string): void {
  if (!clinicId || !patientId) return;
  try {
    const raw = localStorage.getItem(storageKey(clinicId));
    const existing: string[] = raw ? JSON.parse(raw) : [];
    const filtered = existing.filter((id) => id !== patientId);
    filtered.unshift(patientId);
    const trimmed = filtered.slice(0, MAX_RECENT);
    localStorage.setItem(storageKey(clinicId), JSON.stringify(trimmed));
  } catch {
    // Ignora erros de localStorage (quota, modo privado, etc)
  }
}

/**
 * Retorna os ids dos pacientes acessados recentemente, do mais recente pro mais antigo.
 */
export function getRecentPatientIds(clinicId: string): string[] {
  if (!clinicId) return [];
  try {
    const raw = localStorage.getItem(storageKey(clinicId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

/**
 * Remove um paciente da lista de recentes (ex: quando foi deletado).
 */
export function removeRecentPatient(clinicId: string, patientId: string): void {
  if (!clinicId || !patientId) return;
  try {
    const raw = localStorage.getItem(storageKey(clinicId));
    if (!raw) return;
    const existing: string[] = JSON.parse(raw);
    const filtered = existing.filter((id) => id !== patientId);
    localStorage.setItem(storageKey(clinicId), JSON.stringify(filtered));
  } catch {
    // Ignora
  }
}
